import { styled } from '@teko/ui';
import Link from 'next/link';
import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Anchor = styled.a`
  color: unset;
  text-decoration: unset;
`;
const StyledLink = styled(Link)`
  color: unset;
  text-decoration: unset;
`;
const CustomLink = (_a) => {
  var _b = _a, {
    targetPath,
    children,
    targetType = "_self",
    passHref = false
  } = _b, props = __objRest(_b, [
    "targetPath",
    "children",
    "targetType",
    "passHref"
  ]);
  if (!targetPath)
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  const a11yProps = {};
  if (typeof children !== "string") {
    a11yProps["aria-label"] = "Image";
  }
  if (targetPath.startsWith("http") || targetPath.startsWith("/"))
    return /* @__PURE__ */ React.createElement(Anchor, __spreadValues(__spreadValues({
      target: targetType,
      href: targetPath
    }, a11yProps), props), children);
  return /* @__PURE__ */ React.createElement(StyledLink, __spreadValues(__spreadValues({
    href: passHref ? targetPath : `/search?${targetPath}`,
    prefetch: false
  }, a11yProps), props), children);
};

export { CustomLink };
